import { NgModule } from "@angular/core";
import { UiModule } from "../../ui/ui.module";
import { LinkYourBankComponent } from "./components/link-your-bank/link-your-bank.component";
import { OfferDetailsHeadingComponent } from "./components/offer-details-heading/offer-details-heading.component";
import { OfferProductNavigationComponent } from "./components/offer-product-navigation/offer-product-navigation.component";
import { OfferRepaymentNavigationComponent } from "./components/offer-repayment-navigation/offer-repayment-navigation.component";
import { NgxModule } from "../../ngx/ngx.module";
import { OfferCalculatorClosingRequirementsComponent } from "./components/offer-calculator-closing-requirements/offer-calculator-closing-requirements.component";
import { OfferCalculatorDetailsTableModule } from "./components/offer-calculator-details-table/offer-calculator-details-table.module";
import { OfferDrawSliderModule } from "./components/offer-draw-slider/offer-draw-slider.module";
import { OfferCalculatorPaymentScheduleModule } from "./components/offer-calculator-payment-schedule/offer-calculator-payment-schedule.module";

@NgModule({
  imports: [
    UiModule, 
    NgxModule, 
    OfferCalculatorDetailsTableModule,
    OfferDrawSliderModule,
    OfferCalculatorPaymentScheduleModule
  ],
  declarations: [
    OfferDetailsHeadingComponent,
    OfferProductNavigationComponent,
    OfferRepaymentNavigationComponent,
    LinkYourBankComponent, 
    OfferCalculatorClosingRequirementsComponent,
  ],
  exports: [
    UiModule,
    OfferDetailsHeadingComponent,
    OfferProductNavigationComponent,
    OfferRepaymentNavigationComponent,
    LinkYourBankComponent,
    OfferCalculatorClosingRequirementsComponent,
    OfferCalculatorDetailsTableModule,
    OfferDrawSliderModule,
    OfferCalculatorPaymentScheduleModule
  ],
})
export class OfferCommonModule { }
